let firebaseConfig;
if (process.env.NODE_ENV === 'production') {
  firebaseConfig = {
    apiKey: 'AIzaSyD5UV2tfc-72S0a3TpyosCw800PoajiiGU',
    authDomain: 'midies.firebaseapp.com',
    databaseURL: 'https://midies.firebaseio.com',
    projectId: 'midies',
    storageBucket: 'midies.appspot.com',
    messagingSenderId: '319450030710',
    appId: '1:319450030710:web:e7a7390433af4b73937557',
    measurementId: 'G-TF5EMHRBK7'
  };
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyCZYuxVlPNlPnrPXKYfZ5p9HpPxETqqFoY',
    authDomain: 'taso-dev.firebaseapp.com',
    databaseURL: 'https://taso-dev.firebaseio.com',
    projectId: 'taso-dev',
    storageBucket: 'taso-dev.appspot.com',
    messagingSenderId: '908629696952',
    appId: '1:908629696952:web:6315525679a073d55e2f4d',
    measurementId: 'G-QY8BFGY2F0'
  };
}

export default firebaseConfig;
